import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import spaList from "@config/spa"
import store from '@store'

export default [
  // ===
  // 開幕茶會
  // ===
  {
    path: '/opening-reception',
    name: 'opening-reception',
    component: () => lazyLoadView(import('@views/OpeningReception/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
]
